import { adminApiFetch } from './apiService';

export const importService = {
  getRecords: async (params) => {
    const response = await adminApiFetch('imports/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getIds: async (params) => {
    const response = await adminApiFetch('imports/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
};

export default importService;
